import React, { useState } from "react";
import moment from "moment";
import { Col, Row, Dropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  changeCampaignsModal,
  requestActiveChannelCredits,
  requestActiveChannelSource,
  requestActiveEmailChannelReputation,
  requestActiveEmailChannelStatistics,
  setActiveChannelDisplay,
  setActiveEmailChannelStatisticsDate,
} from "../../../../../redux/actions/campaigns";
import { SolidButton } from "../../../../library/button";
import { Title } from "../../../../library/title";
import DropdownMenu from "../../../../universal/dropdown-menu";

const Index = () => {
  const dispatch = useDispatch();

  const selectedCompany = useSelector(
    (state) =>
      state &&
      state.activeCompany &&
      state.activeCompany.activeCompany &&
      state.activeCompany.activeCompany.id
  );

  const sourceLoading = useSelector(
    (state) => state.campaigns.activeChannel.source?.loading
  );
  const source = useSelector(
    (state) => state.campaigns.activeChannel.source?.status
  );

  const channels = useSelector((state) => state.campaigns.channels);
  const channelsLoading = useSelector(
    (state) => state.campaigns.fetchAllChannels.loading
  );

  const activeChannel = useSelector((state) => state.campaigns.activeChannel);

  const [selectChannelDropdownOpen, setSelectChannelDropdownOpen] =
    useState(false);

  const clickDeleteChannel = () => {
    dispatch(changeCampaignsModal({ deleteChannelModal: true }));
  };

  const clickDeleteNumber = () => {
    dispatch(changeCampaignsModal({ deleteNumberModal: true }));
  };

  const clickDeleteDomain = () => {
    dispatch(changeCampaignsModal({ deleteDomainModal: true }));
  };

  const clickNewConfiguration = () => {
    dispatch(changeCampaignsModal({ newChannelModal: true }));
  };

  const selectChannel = (channel) => {
    const filterDate = moment(Date.now()).startOf("month").format("YYYY-MM-DD");
    dispatch(setActiveEmailChannelStatisticsDate(filterDate));
    dispatch(
      setActiveChannelDisplay({
        username: channel.username,
        email: channel.email,
        type: channel.type,
        timestamp: channel.timestamp,
        id: channel.id,
        active: channel.active,
      })
    );
    dispatch(
      requestActiveChannelCredits({
        companyId: selectedCompany,
        channelId: channel.id,
        type: channel.type,
      })
    );
    dispatch(
      requestActiveChannelSource({
        companyId: selectedCompany,
        channelId: channel.id,
        username: channel.username,
        type: channel.type,
      })
    );
    if (channel.type === "email") {
      dispatch(
        requestActiveEmailChannelStatistics({
          companyId: selectedCompany,
          channelId: channel.id,
          date: filterDate,
        })
      );
      dispatch(
        requestActiveEmailChannelReputation({
          companyId: selectedCompany,
          channelId: channel.id,
        })
      );
    }
  };

  const channelSelection = (allChannels) => {
    const result = [];
    if (!channelsLoading && channels && channels.length > 0) {
      channels.map((channel, index, arr) => {
        const id = channel.id;
        const item = {
          title: channel.username,
          key: id,
          active: activeChannel.id === id,
          action: () => selectChannel(channel),
        };
        result.push(item);
      });
    }

    result.push(
      {
        title: "separator",
        key: "separator",
      },
      {
        title: "Ny kanal",
        key: "new",
        active: null,
        action: () => clickNewConfiguration(),
      }
    );
    return result;
  };

  const renderDeleteButton = () => {
    if (!sourceLoading) {
      if (activeChannel.type === "email") {
        if (source?.code === "pending" || source?.code === "success") {
          return (
            <SolidButton
              onClick={() => clickDeleteDomain()}
              color="red"
              icon={<i class="fad fa-trash-alt"></i>}
              spacing="right"
              title="Slett domene"
            />
          );
        } else {
          return null;
        }
      } else {
        if (source?.number) {
          return (
            <SolidButton
              onClick={() => clickDeleteNumber()}
              color="red"
              icon={<i class="fad fa-trash-alt"></i>}
              spacing="right"
              title="Slett nummer"
            />
          );
        } else {
          return null;
        }
      }
    } else {
      return null;
    }
  };

  const renderUpperButtons = () => {
    if (channelsLoading) {
      return (
        <DropdownMenu
          content="regular"
          type="title"
          color="inverse-blue"
          size="regular"
          spacing="right"
          toggle={
            <Dropdown.Toggle disabled={true} id="dropdown-filter">
              <i className="fas fa-circle-notch fa-spin loading-indicator"></i>{" "}
              Henter kanaler.. <i class="fad arrow fa-angle-down"></i>
            </Dropdown.Toggle>
          }
          title="Velg respons"
          options={[]}
        />
      );
    } else {
      if (channels.length > 0) {
        return (
          <>
            {renderDeleteButton()}
            <SolidButton
              onClick={() => clickDeleteChannel()}
              color="gray"
              icon={<i class="fad fa-trash-alt"></i>}
              spacing="right"
              title="Slett kanal"
            />
            <DropdownMenu
              content="regular"
              type="title"
              color="inverse-blue"
              size="regular"
              spacing="right"
              toggle={
                <Dropdown.Toggle
                  onClick={() =>
                    setSelectChannelDropdownOpen(!selectChannelDropdownOpen)
                  }
                  disabled={false}
                  id="dropdown-filter"
                >
                  {activeChannel.username}{" "}
                  <i class="fad arrow fa-angle-down"></i>
                </Dropdown.Toggle>
              }
              title="Velg kanal"
              options={channelSelection()}
              open={selectChannelDropdownOpen}
              setOpen={setSelectChannelDropdownOpen}
            />
          </>
        );
      } else {
        return (
          <SolidButton
            onClick={() => clickNewConfiguration()}
            icon={<i class="fad fa-plus"></i>}
            color="blue"
            spacing="right"
            title="Sett opp ny kanal"
          />
        );
      }
    }
  };

  return (
    <div className="upper-row-container">
      <Row className="upper-row my-auto">
        <Col md={3} className="text-left title-col my-auto">
          <Col className="inner-title-col my-top">
            <Title size="regular">Utsendelser</Title>
          </Col>
        </Col>
        <Col md={9} className="text-right button-col my-top">
          <Col className="inner-button-col">{renderUpperButtons()}</Col>
        </Col>
      </Row>
    </div>
  );
};

export default Index;
